/* eslint-disable no-undef */
export default {
	name: "mark-as-active-inactive-modal",
	props: ["heading", "modalId", "isSaving", "showModal", "isActive"],
	emits: ["closeClicked", "saveButtonClicked", "markUserActiveInactiveSelected"],
	data() {
		return {
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			activeOrInactiveSelectedKey: 1,
			markAsActiveOrInactiveMessage: "Are you sure you want to mark this item as active?",
		};
	},
	methods: {
		onMarkUserActiveInactiveSelected(isActive){
			this.$emit("markUserActiveInactiveSelected", castingUtility.toBoolean(isActive));
		},
		onModalCloseClick() {
			this.$emit("closeClicked", true);
		},
		onModalSaveClick(){
			this.$emit("saveButtonClicked", castingUtility.toBoolean(this.activeOrInactiveSelectedKey));
			//this.$emit("markUserActiveInactiveSelected", castingUtility.toBoolean(this.activeOrInactiveSelectedKey));
		}
	},
	mounted: function () {
        
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		isSaving: {
			handler: function () {
				if(this.isSaving !== null && this.isSaving !== undefined){
					this.formIsSaving = this.isSaving;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		isActive: {
			handler: function () {
				if (this.isActive !== null && this.isActive !== undefined) {
					this.activeOrInactiveSelectedKey = this.isActive ? 0 : 1;
					this.markAsActiveOrInactiveMessage = this.isActive ? "Are you sure you want to mark this item as inactive?" : "Are you sure you want to mark this item as active?";
				}
			},
			immediate: true,
			deep: true
		}
	}
};
